import AxiosService from './AxiosService'

class MasterkeyRestService {
  static get(): Promise<any> {
    return AxiosService.get('/masterkey')
  }

  static updateMasterKeyConfig(masterKeyConfig: any): Promise<any> {
    return AxiosService.put('/masterkey/changeMasterkey', masterKeyConfig)
  }
}

export default MasterkeyRestService
